<!-- 数据树表格 -->
<template>
<basic-container>
  <TreeTable ref="child" v-bind="$attrs">
    <template slot="searchSlot" slot-scope="{query}">
      <slot name="searchSlot" :query="query"></slot>
    </template>
  </TreeTable>
</basic-container>
</template>
<script>
import TreeTable from '@/components/table/template/treeTable';
export default {
components: {
  TreeTable,
},
data() {
  return {}
},
computed: {},
watch: {},
//方法集合
methods: {},
created() {},
mounted() {},
activated() {},
}
</script>
<style lang='scss' scoped></style>